import React from 'react';

interface StatsBarProps {
  totalEmployees: number;
  totalSignOns: number;
  totalSignOffs: number;
  totalVacations: number;
  activeCrewMembers: number;
  onVacation: number;
}

const StatsBar: React.FC<StatsBarProps> = ({
  totalEmployees, totalSignOns, totalSignOffs,
  totalVacations, activeCrewMembers, onVacation,
}) => {
  const items = [
    { value: totalEmployees, label: 'Total Employees', color: 'text-gray-900' },
    { value: totalSignOns, label: 'Total Sign Ons', color: 'text-green-600' },
    { value: totalSignOffs, label: 'Total Sign Offs', color: 'text-red-600' },
    { value: totalVacations, label: 'Total Vacations', color: 'text-blue-600' },
    { value: activeCrewMembers, label: 'Active on Vessels', color: 'text-green-700' },
    { value: onVacation, label: 'On Vacation', color: 'text-blue-700' },
  ];

  return (
    <div className="grid grid-cols-1 md:grid-cols-6 gap-4">
      {items.map((stat, i) => (
        <div key={i} className="card p-4">
          <div className="text-center">
            <div className={`text-2xl font-bold ${stat.color}`}>{stat.value}</div>
            <div className="text-sm text-gray-600">{stat.label}</div>
          </div>
        </div>
      ))}
    </div>
  );
};

export default StatsBar;
